import { ICreateDisciplinasArquivosUseCase } from "../../../presentation/useCases/create/create_disciplinas_arquivos_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * CreateDisciplinasArquivosUseCase
 */

export class CreateDisciplinasArquivosUseCase implements ICreateDisciplinasArquivosUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async createDisciplinasArquivos(): Promise<void> {}
}
